import { z } from 'zod';

export const zodDeliveryNoteLatestOriginalPdfAdminEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('asset'),
  z.literal('delivery_note'),
  z.uuid(),
  z.literal('original_pdf'),
]);
